exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pagination-container[data-v-7510a361] {\n  background: #fff;\n  padding: 0.16667rem 0.08333rem;\n  text-align: right;\n}\n.pagination-container.hidden[data-v-7510a361] {\n  display: none;\n}\n.slot-block[data-v-7510a361] {\n  display: inline-block;\n}\n", ""]);

// exports
